/**
 * A bye is a scheduled round with no opposition. It should stay visible on the
 * schedule (parents want to know there's no game) but must never ask anyone to
 * RSVP, and must never count as a player shortage.
 *
 * The canonical marker is `status = 'bye'`. Legacy rows only carry the opponent
 * name "Bye", so we still recognise those.
 */
export interface ByeLike {
  status?: string | null;
  opponent?: string | null;
}

export function isBye(game: ByeLike | null | undefined): boolean {
  if (!game) return false;
  if (game.status === "bye") return true;
  const opp = (game.opponent || "").trim().toLowerCase();
  return opp === "bye" || opp === "bye week" || opp === "(bye)";
}

/** Fields written when a match is turned into a bye. */
export const BYE_UPDATE = {
  status: "bye",
  rsvp_enabled: false,
  voting_open: false,
  cancellation_reason: null,
} as const;

/** Fields written when a bye is turned back into a normal match. */
export const UNBYE_UPDATE = {
  status: "scheduled",
  rsvp_enabled: true,
} as const;
